<template>
	<el-container class="log">
		<el-aside width="180px">
			<nav-menu></nav-menu>
		</el-aside>
		<el-main class="content">
			<el-card class="screen-box">
				<el-form ref="form" :model="searchForm" :inline="true" size="small">
					<el-form-item label="人员姓名:">
						<el-input placeholder="请输入人员姓名" v-model="searchForm.personName"></el-input>
					</el-form-item>
					<el-form-item label="人员编号:">
						<el-input placeholder="请输入人员编号" v-model="searchForm.personNo"></el-input>
					</el-form-item>
					<el-form-item label="出入类型:">
						<el-select placeholder="请选择出入类型" v-model="searchForm.outInType">
							<el-option label="未知" value="-1"></el-option>
							<el-option label="进门" value="0"></el-option>
							<el-option label="出门" value="1"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="人员类型:">
						<el-select placeholder="请选择人员类型" v-model="searchForm.personType">
							<el-option label="未知" value="0"></el-option>
							<el-option label="教职工" value="1"></el-option>
							<el-option label="学生" value="2"></el-option>
							<el-option label="家长" value="3"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="是否推送:">
						<el-select placeholder="请选择是否推送" v-model="searchForm.isPush">
							<el-option label="是" value="true"></el-option>
							<el-option label="否" value="false"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button @click="search()" icon="el-icon-search" type="primary" size="small">查询</el-button>
						<el-button @click="resetForm()" icon="el-icon-delete" size="small">清空</el-button>
					</el-form-item>
				</el-form>
			</el-card>
			<el-card class="table-box">
				<el-table :data="tableList" id="table" border>
					<el-table-column type="index" width="50"></el-table-column>
					<template v-for="(item, index) in tableLabel">
						<el-table-column :key="index" :prop="item.prop" :label="item.label" :formatter="item.formatter">
						</el-table-column>
					</template>
					<el-table-column label="操作" width="80">
						<template slot-scope="scope">
							<el-button type="text" size="mini" @click="againPush(scope.row)">重新推送</el-button>
						</template>
					</el-table-column>
				</el-table>
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchForm.page" :page-sizes="pageSizes" :page-size="searchForm.limit" layout="total, sizes, prev, pager, next, jumper" :total="totalCount"></el-pagination>
			</el-card>
		</el-main>
	</el-container>
</template>

<script>
	import { messagePageApi,againPushApi } from "@/axios/api";
	export default {
		name: "Log",
		data() {
			return {
				tableList: [],
				tableLabel: [{
					label: "人员名称",
					prop: "personName"
				}, {
					label: "人脸",
					prop: "pictureUrl",
					formatter: (row) => {
						return <el-popover placement="right" width="500" trigger="click"><el-image src={row.pictureUrl}></el-image><el-image style="width:38px;height:38px;"  slot="reference" src={row.pictureUrl}></el-image></el-popover>
					}
				}, {
					label: "工号",
					prop: "personNo"
				}, {
					label: "体温",
					prop: "bodyTemperature"
				}, {
					label: "出入类型",
					prop: "outInType",
					formatter: (row) => {
						if(row.outInType == '-1'){
							return '未知'
						}else if(row.outInType == '0'){
							return '进门'
						}else if(row.outInType == '1'){
							return '出门'
						}
					}
				}, {
					label: "人员类型",
					prop: "personType",
					formatter: (row) => {
						if(row.personType == '0'){
							return '未知'
						}else if(row.personType == '1'){
							return '教职工'
						}else if(row.personType == '2'){
							return '学生'
						}else if(row.personType == '3'){
							return '家长'
						}
					}
				}, {
					label: "事件",
					prop: "eventCode",
					formatter: (row) => {
						if(row.eventCode == '10114'){
							return '人脸开门'
						}else{
							return '刷卡开门'
						}
					}
				}, {
					label: "闸机时间",
					prop: "dateTime"
				}, {
					label: "发送时间",
					prop: "createTime"
				}],
				searchForm: {
					isSearchCount:true,
					page:1,
					limit:10,
					outInType:'',
					personName:'',
					personNo:'',
					personType:'',
					isPush:''
				},
				totalCount:0,
				pageSizes:[10],
			}
		},
		created(){
			this.getData();
		},
		methods:{
			getData(){
				messagePageApi(this.searchForm).then((res) => {
					if (res.code == 200){
						this.tableList = res.data.records;
						this.totalCount = res.data.total;
					}
				}).catch((err) => {});
			},
			//查询
			search(){
				this.searchForm.page = 1;
				this.getData();
			},
			//清空
			resetForm(){
				this.searchForm = {
					isSearchCount:true,
					page:1,
					limit:10,
					outInType:'',
					personName:'',
					personNo:'',
					personType:'',
					isPush:''
				};
				this.getData();
			},
			//重新推送
			againPush(row){
				againPushApi({id:row.id}).then((res) => {
					if (res.code === 200){
						if (res.data) {
							this.$message.success("重新推送成功！");
						}else {
							this.$message.error("重新推送失败！");
						}
					}else {
						this.$message.error("重新推送失败！");
					}
				}).catch((err) => {});
			},
			// 分页
			handleSizeChange(val) {
				this.searchForm.limit=val // 改变每页显示的条数 
				this.searchForm.page=1 // 注意：在改变每页显示的条数时，要将页码显示到第一页
				this.getData() // 点击每页显示的条数时，显示第一页
			},
			handleCurrentChange(val) {
				this.searchForm.page=val // 改变默认的页数
				this.getData() // 切换页码时，要获取每页显示的条数
			}
		}
	}
</script>

<style lang="less" scoped>
	.screen-box{
		margin-left: 12px;
	}
	.table-box{
		margin-left: 12px;
		min-height: 83vh;
	}
</style>
